import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'
import { Subject } from 'rxjs'

const onUpdateData = new Subject()

export const todoService = {
  getData,
  add,
  update,
  getDataById,
  deleteDataById,
  onUpdateData
}

function getData ({ q = '', limit = '999999999', ordering = '', offset = 0 }) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/todos/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(todos => {
      return todos
    })
}

function getDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/todos/${id}/?expand=organizations_todos,organizations_todos.organization,created_by,modified_by`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(todos => {
      return todos
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/todos/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(todos => {
      return todos
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/todos/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(todos => {
      return todos
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/todos/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(todos => {
      return todos
    })
}



// WEBPACK FOOTER //
// ./src/services/todo.service.js